export const path = "/tasks-aluna";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "TASKS ALUNA",
  section: "ALUNA",
  group: null,
  order: 6,
  roles: [
    "Authenticated",
    "aluna",
    "design",
    "aluna-management",
    "master-aluna-rrss",
    "aluna-afiliado",
  ],
};
